import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getrapportwell } from "../Redux/Actions/RapportActions";
import { getrapporttwin } from "../Redux/Actions/RapportTwinAction";
import { getrapportspintoss } from "../Redux/Actions/RapportSpintossAction";
import axios from 'axios';

import { Table, Container } from "react-bootstrap";
import { BarChart } from '@mui/x-charts/BarChart';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import "./Home.css"; // Feuille CSS pour styles
import { getMyRequests, getRecivedRequests } from "../Redux/Actions/RequestActions";
import Login from "./Login";


import { useNavigate } from "react-router-dom";


function Home() {
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const user = useSelector(state => state.AuthReducer?.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role !== 'admin' && user.role !== 'useradmin') {
      navigate('/welcome');
    }
  }, [user, navigate]);

  const [billsValises, setBillsValises] = useState([]);

  useEffect(() => {
    dispatch(getrapportwell());
    dispatch(getMyRequests());
    dispatch(getRecivedRequests());
    dispatch(getrapportspintoss());
    dispatch(getrapporttwin());

    const fetchBills = async () => {
      try {
        const res = await axios.get("/api/BillsValises/getAllBillsV", {
          headers: { Authorization: token ? `Bearer ${token}` : "" }
        });
        setBillsValises(res.data);
      } catch (err) {
        console.log("Error fetching bills:", err);
      }
    };
    fetchBills();
  }, [dispatch, token]);

  const rapports = useSelector((state) => state.RapportReducer.rapports);

  // Filtrer les rapports pour le mois actuel
  const getCurrentMonthRange = () => {
    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), 1); // 1er jour du mois
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Dernier jour du mois
    return { start, end };
  };

  const fetchMonthlyReports = () => {
    const { start, end } = getCurrentMonthRange();
    return rapports.filter((entry) => {
      const entryDate = new Date(entry.DateCollect);
      return entryDate >= start && entryDate <= end;
    });
  };

  const filteredData = fetchMonthlyReports();

  // Calcul des totaux
  const calculateTotals = (data) => {
    const totalAmount = parseFloat(
      data.reduce((acc, curr) => acc + curr.Amount, 0).toFixed(3)
    );
    const totalExpenses = parseFloat(
      data.reduce((acc, curr) => acc + curr.MonthExpenses, 0).toFixed(3));
    const netResult = parseFloat((totalAmount - totalExpenses).toFixed(3));

    return { totalAmount, totalExpenses, netResult };
  };

  const fetchMonthlyBills = () => {
    const { start, end } = getCurrentMonthRange();
    return billsValises.filter((bill) => {
      const entryDate = new Date(bill.date || bill.createdAt);
      return entryDate >= start && entryDate <= end && bill.status !== "cancelled";
    });
  };

  const monthlyBills = fetchMonthlyBills();

  const bagngoBills = monthlyBills.filter(b => {
    const locName = (b.localisation?.name || b.localisation || "").toString().toLowerCase();
    return locName.includes('bagngo') || locName.includes('bng');
  });
  const espaceBills = monthlyBills.filter(b => {
    const locName = (b.localisation?.name || b.localisation || "").toString().toLowerCase();
    if (locName.includes('espace') || locName.includes('e-space')) return true;
    const userName = (b.user?.name || b.userName || "").toString().toLowerCase();
    return userName.includes('espace') || userName.includes('e-space');
  });
  const jumpZoneBills = monthlyBills.filter(b => {
    const locName = (b.localisation?.name || b.localisation || "").toString().toLowerCase();
    return locName.includes('jump');
  });

  const bagngoSales = parseFloat(bagngoBills.reduce((acc, curr) => acc + (curr.total || 0), 0).toFixed(3));
  const espaceSales = parseFloat(espaceBills.reduce((acc, curr) => acc + (curr.total || 0), 0).toFixed(3));
  const jumpZoneSales = parseFloat(jumpZoneBills.reduce((acc, curr) => acc + (curr.total || 0), 0).toFixed(3));

  const bagngoReports = useMemo(() => filteredData.filter(r => r.localisation?.toLowerCase().includes('bagngo') || r.localisation?.toLowerCase().includes('bng')), [filteredData]);
  const espaceReports = useMemo(() => filteredData.filter(r => r.localisation?.toLowerCase().includes('espace') || r.localisation?.toLowerCase().includes('e-space')), [filteredData]);
  const jumpZoneReports = useMemo(() => filteredData.filter(r => r.localisation?.toLowerCase().includes('jump')), [filteredData]);
  
  const wellnessReports = useMemo(() => filteredData.filter(r => 
    !r.localisation?.toLowerCase().includes('bagngo') && 
    !r.localisation?.toLowerCase().includes('bng') && 
    !r.localisation?.toLowerCase().includes('espace') && 
    !r.localisation?.toLowerCase().includes('e-space') &&
    !r.localisation?.toLowerCase().includes('jump')
  ), [filteredData]);

  const bagngoTotals = calculateTotals(bagngoReports);
  const espaceTotals = calculateTotals(espaceReports);
  const jumpZoneTotals = calculateTotals(jumpZoneReports);
  const wellnessTotals = calculateTotals(wellnessReports);

  const { totalExpenses: bagngoExpenses } = bagngoTotals;
  const { totalExpenses: espaceExpenses } = espaceTotals;
  const { totalExpenses: jumpZoneExpenses } = jumpZoneTotals;
  const { totalAmount: wellnessAmount, totalExpenses: wellnessExpenses, netResult: wellnessNet } = wellnessTotals;

  const bagngoAmount = bagngoSales + bagngoTotals.totalAmount;
  const espaceAmount = espaceSales + espaceTotals.totalAmount;
  const jumpZoneAmount = jumpZoneSales + jumpZoneTotals.totalAmount;

  const bagngoNet = parseFloat((bagngoAmount - bagngoExpenses).toFixed(3));
  const espaceNet = parseFloat((espaceAmount - espaceExpenses).toFixed(3));
  const jumpZoneNet = parseFloat((jumpZoneAmount - jumpZoneExpenses).toFixed(3));

  // Global values for the "General" section (Wellness + BagnGo)
  // E-space and JumpZone are now moved to Twin Park section
  const totalAmount = parseFloat((wellnessAmount + bagngoAmount).toFixed(3));
  const totalExpenses = parseFloat((wellnessExpenses + bagngoExpenses).toFixed(3));
  const netResult = parseFloat((totalAmount - totalExpenses).toFixed(3));

  // Removed somme state

  const RapportsTwin = useSelector((state) => state.RapportTwinReducer.RapportsTwin);

  // Fonction pour filtrer les rapports du mois courant
  const filterCurrentMonthData = (data) => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    return data.filter((rapport) => {
      const reportDate = new Date(rapport.DateCollect);
      return reportDate.getMonth() === currentMonth && reportDate.getFullYear() === currentYear;
    });
  };

  // Vérification si 'rapports' est un tableau valide
  const validRapports = Array.isArray(RapportsTwin) ? RapportsTwin : [];

  // NOTE: getrapporttwin() est déjà dispatché dans le premier useEffect ci-dessus

  // Fonction pour calculer les totaux
  const calcul = (data) => {
    const totalAmount = data.reduce((acc, cur) => acc + (cur.TotalAmount || 0), 0);
    const totalDailyExpenses = data.reduce(
      (acc, cur) => acc + (cur.DailyExpenses || 0),
      0
    );
    const resultatnet = totalAmount - totalDailyExpenses;

    return {
      totalAmount,
      totalDailyExpenses,
      resultatnet,
    };
  };

  // Fonction pour exclure les données liées au partenariat
  const filterNonPartnershipData = (data) => {
    return data.filter((cur) => {
      return !(
        cur.MachineBoxe ||
        cur.MachineFoot ||
        cur.MachineBoxeEnfant ||
        cur.BillardAmericain ||
        cur.BabyFoot ||
        cur.Cinema ||
        cur.BallesGift
      );
    });
  };

  // Regroupement des rapports par localisation
  const groupByLocalisation = (data) => {
    return data.reduce((acc, el) => {
      if (!acc[el.localisation]) {
        acc[el.localisation] = [];
      }
      acc[el.localisation].push(el);
      return acc;
    }, {});
  };

  // Application du filtre pour inclure TOUS les rapports Twin Park (Standard + Partenariat)
  // Et fusionner avec les autres espaces (E-space, JumpZone)
  const combinedTwinParkReports = useMemo(() => {
    const currentMonthTwin = filterCurrentMonthData(validRapports);
    
    // Normaliser les rapports Twin Park pour inclure la part partenariat dans le total
    const normalizedTwin = currentMonthTwin.map(r => {
      const machineTotal = (r.MachineBoxe || 0) + (r.MachineFoot || 0) + (r.MachineBoxeEnfant || 0) + 
                          (r.BillardAmericain || 0) + (r.BabyFoot || 0) + (r.Cinema || 0) + (r.BallesGift || 0);
      return {
        ...r,
        TotalAmount: (r.TotalAmount || 0) + machineTotal,
        DailyExpenses: (r.DailyExpenses || 0),
        isTwinPark: true
      };
    });

    // Normaliser les rapports E-space et JumpZone
    const normalizedOther = [...espaceReports, ...jumpZoneReports].map(r => ({
      ...r,
      localisation: r.localisation,
      TotalAmount: (r.Amount || 0),
      DailyExpenses: (r.MonthExpenses || 0),
      isOtherSpace: true
    }));

    return [...normalizedTwin, ...normalizedOther];
  }, [validRapports, espaceReports, jumpZoneReports]);

  // Regroupement des rapports par localisation
  const groupedReports = useMemo(() => groupByLocalisation(combinedTwinParkReports), [combinedTwinParkReports]);

  // Calcul des sommes globales Twin Park (incluant tout : Rapports + Ventes POS E-space/JumpZone)
  const somme = useMemo(() => {
    const baseCalcul = calcul(combinedTwinParkReports);
    return {
      ...baseCalcul,
      totalAmount: baseCalcul.totalAmount + espaceSales + jumpZoneSales,
      resultatnet: (baseCalcul.totalAmount + espaceSales + jumpZoneSales) - baseCalcul.totalDailyExpenses,
    };
  }, [combinedTwinParkReports, espaceSales, jumpZoneSales]);

  const myRequests = useSelector((state) => state.ReducersRequest.myRequests);
  const myRecivedRequest = useSelector((state) => state.ReducersRequest.myRecivedRequest);

  // Fonction pour calculer le nombre de demandes non confirmées dans une catégorie donnée
  const categories = ["All", "For You Today", "Repetitive Tasks", "New Project"];

  // Fonction pour compter les demandes non confirmées
  const countUnconfirmedRequests = (requests, category) => {
    // Si la catégorie est "All", on additionne les demandes non confirmées des trois catégories spécifiques
    if (category === "All") {
      const allCategories = ["For You Today", "Repetitive Tasks", "New Project"];
      let count = 0;

      allCategories.forEach((cat) => {
        count += requests.filter(
          (request) =>
            request.selectedCategory?.trim().toLowerCase() === cat.toLowerCase() &&
            request.destinataire.some(destinataire => destinataire.status !== "Confirmed")
        ).length;
      });

      return count;
    }

    // Pour les autres catégories, on filtre normalement
    return requests.filter(
      (request) =>
        request.selectedCategory?.trim().toLowerCase() === category.toLowerCase() &&
        request.destinataire.some(destinataire => destinataire.status !== "Confirmed")
    ).length;
  };



  const rawRapportsMensuels = useSelector((state) => state.RapportSpintossReducer?.RapportsSpintoss);
  const rapportsMensuels = rawRapportsMensuels || [];

  // Filtrer les rapports du mois courant et calculer les totaux
  const currentMonthData = useMemo(() => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    const filteredReports = rapportsMensuels.filter((rapport) => {
      const reportDate = new Date(rapport.DateCollect);
      return (
        reportDate.getMonth() === currentMonth &&
        reportDate.getFullYear() === currentYear
      );
    });

    const totalIncome = parseFloat(
      filteredReports.reduce((acc, cur) => acc + (cur.TotalAmount || 0), 0).toFixed(3)
    );

    const totalDailyExpenses = parseFloat(
      filteredReports.reduce((acc, cur) => acc + (cur.DailyExpenses || 0), 0).toFixed(3)
    );

    const resultatNet = parseFloat((totalIncome - totalDailyExpenses).toFixed(3));


    return { filteredReports, totalIncome, totalDailyExpenses, resultatNet };
  }, [rapportsMensuels]);

  const { totalIncome, totalDailyExpenses, resultatNet } = currentMonthData;

  const tableData = [
    {
      libelle: "Spintoss",
      totalIncome: totalIncome,
      totalDailyExpenses: totalDailyExpenses,
      resultatNet: resultatNet,
    },
  ];


  const calculateGlobalTotals = () => {
    // somme.totalAmount now includes standard twin park + partnership + espace + jumpzone
    // totalIncome is Spintoss
    // totalAmount is Wellness + BagnGo
    const globalAmount = (parseFloat(totalAmount) + parseFloat(totalIncome) + parseFloat(somme.totalAmount)).toFixed(3);
    const globalExpenses = (parseFloat(totalExpenses) + parseFloat(totalDailyExpenses) + parseFloat(somme.totalDailyExpenses)).toFixed(3);
    const globalNetResult = globalAmount - globalExpenses;

    return { globalAmount, globalExpenses, globalNetResult };
  };

  const { globalAmount, globalExpenses, globalNetResult } = calculateGlobalTotals();


  const groupedSpintossReports = useMemo(() => {
    return groupByLocalisation(currentMonthData.filteredReports);
  }, [currentMonthData.filteredReports]);

  const spintossChartData = Object.keys(groupedSpintossReports).map((loc) => {
    const data = groupedSpintossReports[loc];
    const totalIncome = parseFloat(data.reduce((acc, cur) => acc + (cur.TotalAmount || 0), 0).toFixed(3));
    const totalDailyExpenses = parseFloat(data.reduce((acc, cur) => acc + (cur.DailyExpenses || 0), 0).toFixed(3));
    return {
      localisation: loc,
      Recettes: totalIncome,
      Dépenses: totalDailyExpenses,
    };
  });

  const twinParkChartData = Object.keys(groupedReports).map((loc) => {
    const totals = calcul(groupedReports[loc]);
    return {
      localisation: loc,
      Recettes: totals.totalAmount,
      Dépenses: totals.totalDailyExpenses,
    };
  });

  const wellnessChartData = [
    { localisation: 'Wellness', Recettes: wellnessAmount || 0, Dépenses: wellnessExpenses || 0 }
  ];

  const bagngoChartData = [
    { localisation: 'BagnGo', Recettes: bagngoAmount || 0, Dépenses: bagngoExpenses || 0 }
  ];

  const espaceChartData = [
    { localisation: 'E-space', Recettes: espaceAmount || 0, Dépenses: espaceExpenses || 0 }
  ];

  const twinToysTotal = useMemo(() => {
    return combinedTwinParkReports.reduce((acc, curr) => acc + (curr.TwinToys || 0), 0);
  }, [combinedTwinParkReports]);

  const twinToysChartData = [
    { localisation: 'Jouets', Recettes: twinToysTotal || 0, Dépenses: 0 }
  ];

  const sectionsData = [
    { section: 'Spintoss', Recettes: totalIncome || 0, Dépenses: totalDailyExpenses || 0 },
    { section: 'Wellness', Recettes: wellnessAmount || 0, Dépenses: wellnessExpenses || 0 },
    { section: 'Twin Park', Recettes: somme.totalAmount || 0, Dépenses: somme.totalDailyExpenses || 0 },
    { section: 'BagnGo', Recettes: bagngoAmount || 0, Dépenses: bagngoExpenses || 0 },
    { section: 'Jouets', Recettes: twinToysTotal || 0, Dépenses: 0 }
  ];

  const pieData = [
    { id: 0, value: globalNetResult > 0 ? parseFloat(globalNetResult) : 0, label: 'Bénéfice Net', color: '#05cd99' },
    { id: 1, value: parseFloat(globalExpenses), label: 'Dépenses', color: '#ee5d50' },
  ];

  return (
    <div className="dashboard-root">
      {token ? (
        <div className="dashboard-container">
          <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
            <div>
              <h2>Tableau de Bord Global</h2>
              <p className="dashboard-subtitle">Aperçu financier et opérationnel du mois en cours</p>
            </div>
            <button
              type="button"
              onClick={() => navigate('/BrandStatsHub')}
              style={{
                background: 'linear-gradient(135deg, #059669 0%, #00875a 100%)',
                color: '#ffffff',
                border: 'none',
                padding: '10px 18px',
                borderRadius: '12px',
                fontWeight: '800',
                fontSize: '0.9rem',
                cursor: 'pointer',
                boxShadow: '0 4px 14px rgba(5, 150, 105, 0.3)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              🏢 Statistiques par Enseigne
            </button>
          </div>

          {/* KPI Cards */}
          <div className="kpi-grid">
            <div className="kpi-card">
              <div className="kpi-icon blue">💰</div>
              <div className="kpi-info">
                <h4>Recettes Globales</h4>
                <p>{globalAmount} TND</p>
              </div>
            </div>
            <div className="kpi-card">
              <div className="kpi-icon red">📉</div>
              <div className="kpi-info">
                <h4>Dépenses Globales</h4>
                <p>{globalExpenses} TND</p>
              </div>
            </div>
            <div className="kpi-card">
              <div className="kpi-icon green">📈</div>
              <div className="kpi-info">
                <h4>Résultat Net</h4>
                <p>{parseFloat(globalNetResult).toFixed(3)} TND</p>
              </div>
            </div>
            <div className="kpi-card">
              <div className="kpi-icon purple">📋</div>
              <div className="kpi-info">
                <h4>Demandes en attente</h4>
                <p>{countUnconfirmedRequests(myRecivedRequest, "All")}</p>
              </div>
            </div>
          </div>

          {/* Charts Section */}
          <div className="charts-grid">
            <div className="chart-card">
              <h3>Répartition Globale (Recettes vs Dépenses)</h3>
              {parseFloat(globalNetResult > 0 ? globalNetResult : 0) + parseFloat(globalExpenses) > 0 ? (
                <PieChart
                  series={[
                    {
                      data: pieData,
                      innerRadius: 60,
                      outerRadius: 100,
                      paddingAngle: 5,
                      cornerRadius: 10,
                    },
                  ]}
                  height={300}
                  margin={{ top: 10, bottom: 10, left: 10, right: 10 }}
                />
              ) : (
                <p className="no-data" style={{textAlign: "center", marginTop: "100px"}}>Aucune donnée</p>
              )}
            </div>
            <div className="chart-card">
              <h3>Performance Mensuelle par Section</h3>
              <BarChart
                dataset={sectionsData}
                xAxis={[{ scaleType: 'band', dataKey: 'section' }]}
                series={[
                  { dataKey: 'Recettes', label: 'Recettes', color: '#4318FF' },
                  { dataKey: 'Dépenses', label: 'Dépenses', color: '#ee5d50' }
                ]}
                height={300}
                margin={{ top: 20, bottom: 30, left: 40, right: 10 }}
              />
            </div>
          </div>

          {/* Detailed Reports Section */}
          <div className="reports-container">
            
            {/* Rapport Wellness */}
            <div className="table-card wellness">
              <h3>Rapport Wellness</h3>
              <div className="card-content-split">
                <div className="chart-container">
                  <BarChart
                    dataset={wellnessChartData}
                    xAxis={[{ scaleType: 'band', dataKey: 'localisation' }]}
                    series={[
                      { dataKey: 'Recettes', label: 'Recettes', color: '#05cd99' },
                      { dataKey: 'Dépenses', label: 'Dépenses', color: '#ee5d50' }
                    ]}
                    height={250}
                  />
                </div>
                <div className="chart-container">
                  {(wellnessNet > 0 ? wellnessNet : 0) + wellnessExpenses > 0 ? (
                    <PieChart
                      series={[{
                        data: [
                          { id: 0, value: wellnessNet > 0 ? wellnessNet : 0, label: 'Bénéfice', color: '#05cd99' },
                          { id: 1, value: wellnessExpenses, label: 'Dépenses', color: '#ee5d50' }
                        ],
                        innerRadius: 40,
                        outerRadius: 80,
                      }]}
                      height={250}
                    />
                  ) : (
                    <p className="no-data" style={{textAlign: "center", marginTop: "100px"}}>Aucune donnée</p>
                  )}
                </div>
                <div className="table-container">
                  <Table responsive className="dashboard-table">
                    <thead>
                      <tr>
                        <th>Libellé</th>
                        <th>Recettes</th>
                        <th>Dépenses</th>
                        <th>Net</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Wellness</td>
                        <td>{wellnessAmount}</td>
                        <td>{wellnessExpenses}</td>
                        <td><span className={wellnessNet >= 0 ? 'text-success' : 'text-danger'}>{wellnessNet}</span></td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>

            {/* Rapport BagnGo */}
            <div className="table-card bagngo">
              <h3>Rapport BagnGo</h3>
              <div className="card-content-split">
                <div className="chart-container">
                  <BarChart
                    dataset={bagngoChartData}
                    xAxis={[{ scaleType: 'band', dataKey: 'localisation' }]}
                    series={[
                      { dataKey: 'Recettes', label: 'Recettes', color: '#f97316' },
                      { dataKey: 'Dépenses', label: 'Dépenses', color: '#ee5d50' }
                    ]}
                    height={250}
                  />
                </div>
                <div className="chart-container">
                  {(bagngoNet > 0 ? bagngoNet : 0) + bagngoExpenses > 0 ? (
                    <PieChart
                      series={[{
                        data: [
                          { id: 0, value: bagngoNet > 0 ? bagngoNet : 0, label: 'Bénéfice', color: '#f97316' },
                          { id: 1, value: bagngoExpenses, label: 'Dépenses', color: '#ee5d50' }
                        ],
                        innerRadius: 40,
                        outerRadius: 80,
                      }]}
                      height={250}
                    />
                  ) : (
                    <p className="no-data" style={{textAlign: "center", marginTop: "100px"}}>Aucune donnée</p>
                  )}
                </div>
                <div className="table-container">
                  <Table responsive className="dashboard-table">
                    <thead>
                      <tr>
                        <th>Libellé</th>
                        <th>Recettes</th>
                        <th>Dépenses</th>
                        <th>Net</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>BagnGo</td>
                        <td>{bagngoAmount}</td>
                        <td>{bagngoExpenses}</td>
                        <td><span className={bagngoNet >= 0 ? 'text-success' : 'text-danger'}>{bagngoNet}</span></td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>


            {/* Rapport Twin Park */}
            <div className="table-card">
              <h3>Rapport Twin Park</h3>
              <div className="card-content-split">
                <div className="chart-container">
                  <BarChart
                    dataset={twinParkChartData}
                    xAxis={[{ scaleType: 'band', dataKey: 'localisation' }]}
                    series={[
                      { dataKey: 'Recettes', label: 'Recettes', color: '#4318FF' },
                      { dataKey: 'Dépenses', label: 'Dépenses', color: '#ee5d50' }
                    ]}
                    height={250}
                  />
                </div>
                <div className="chart-container">
                  {(somme.resultatnet > 0 ? somme.resultatnet : 0) + somme.totalDailyExpenses > 0 ? (
                    <PieChart
                      series={[{
                        data: [
                          { id: 0, value: somme.resultatnet > 0 ? somme.resultatnet : 0, label: 'Bénéfice', color: '#4318FF' },
                          { id: 1, value: somme.totalDailyExpenses, label: 'Dépenses', color: '#ee5d50' }
                        ],
                        innerRadius: 40,
                        outerRadius: 80,
                      }]}
                      height={250}
                    />
                  ) : (
                    <p className="no-data" style={{textAlign: "center", marginTop: "100px"}}>Aucune donnée</p>
                  )}
                </div>
                <div className="table-container">
                  {Object.keys(groupedReports).length > 0 ? (
                    <Table responsive className="dashboard-table">
                      <thead>
                        <tr>
                          <th>Localisation</th>
                          <th>Recettes</th>
                          <th>Dépenses</th>
                          <th>Net</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(groupedReports).map((localisation, idx) => {
                          const reportsForLocalisation = groupedReports[localisation];
                          const totalsForLocalisation = calcul(reportsForLocalisation);
                          
                          // Ajouter les ventes POS pour E-space et JumpZone
                          let finalAmount = totalsForLocalisation.totalAmount;
                          const locLower = localisation.toLowerCase();
                          if (locLower.includes('espace') || locLower.includes('e-space')) finalAmount += espaceSales;
                          if (locLower.includes('jump')) finalAmount += jumpZoneSales;
                          
                          const finalNet = finalAmount - totalsForLocalisation.totalDailyExpenses;

                          return (
                            <tr key={idx}>
                              <td>{localisation}</td>
                              <td>{finalAmount.toFixed(3)}</td>
                              <td>{totalsForLocalisation.totalDailyExpenses.toFixed(3)}</td>
                              <td><span className={finalNet >= 0 ? 'text-success' : 'text-danger'}>{finalNet.toFixed(3)}</span></td>
                            </tr>
                          );
                        })}
                        <tr className="table-total-row">
                          <td>Global</td>
                          <td>{somme.totalAmount.toFixed(3)}</td>
                          <td>{somme.totalDailyExpenses.toFixed(3)}</td>
                          <td><span className={somme.resultatnet >= 0 ? 'text-success' : 'text-danger'}>{somme.resultatnet.toFixed(3)}</span></td>
                        </tr>
                      </tbody>
                    </Table>
                  ) : (
                    <p className="no-data">Aucun rapport disponible pour ce mois.</p>
                  )}
                </div>
              </div>
            </div>

            {/* Ventes Jouets (TwinToys) */}
            <div className="table-card twintoys">
              <h3>Ventes Jouets (TwinToys)</h3>
              <div className="card-content-split">
                <div className="chart-container">
                  <BarChart
                    dataset={twinToysChartData}
                    xAxis={[{ scaleType: 'band', dataKey: 'localisation' }]}
                    series={[
                      { dataKey: 'Recettes', label: 'Ventes', color: '#ec4899' }
                    ]}
                    height={250}
                  />
                </div>
                <div className="chart-container">
                  {twinToysTotal > 0 ? (
                    <PieChart
                      series={[{
                        data: [
                          { id: 0, value: twinToysTotal, label: 'Jouets', color: '#ec4899' }
                        ],
                        innerRadius: 40,
                        outerRadius: 80,
                      }]}
                      height={250}
                    />
                  ) : (
                    <p className="no-data" style={{textAlign: "center", marginTop: "100px"}}>Aucune donnée</p>
                  )}
                </div>
                <div className="table-container">
                  <Table responsive className="dashboard-table">
                    <thead>
                      <tr>
                        <th>Libellé</th>
                        <th>Ventes (Incluses dans Twin Park)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>TwinToys</td>
                        <td><span className="text-success">{twinToysTotal.toFixed(3)}</span></td>
                      </tr>
                    </tbody>
                  </Table>
                      </div>
              </div>
            </div>

            {/* Rapport Spintoss */}
            <div className="table-card">
              <h3>Rapport Spintoss</h3>
              <div className="card-content-split">
                <div className="chart-container">
                  <BarChart
                    dataset={spintossChartData}
                    xAxis={[{ scaleType: 'band', dataKey: 'localisation' }]}
                    series={[
                      { dataKey: 'Recettes', label: 'Recettes', color: '#4318FF' },
                      { dataKey: 'Dépenses', label: 'Dépenses', color: '#ee5d50' }
                    ]}
                    height={250}
                  />
                </div>
                <div className="chart-container">
                  {(totalIncome > 0 ? totalIncome : 0) + totalDailyExpenses > 0 ? (
                    <PieChart
                      series={[{
                        data: [
                          { id: 0, value: totalIncome > 0 ? totalIncome : 0, label: 'Net', color: '#4318FF' },
                          { id: 1, value: totalDailyExpenses, label: 'Dépenses', color: '#ee5d50' }
                        ],
                        innerRadius: 40,
                        outerRadius: 80,
                      }]}
                      height={250}
                    />
                  ) : (
                    <p className="no-data" style={{textAlign: "center", marginTop: "100px"}}>Aucune donnée</p>
                  )}
                </div>
                <div className="table-container">
                  {Object.keys(groupedSpintossReports).length > 0 ? (
                    <Table responsive className="dashboard-table">
                      <thead>
                        <tr>
                          <th>Localisation</th>
                          <th>Recettes</th>
                          <th>Dépenses</th>
                          <th>Net</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(groupedSpintossReports).map((localisation, idx) => {
                          const reportsForLocalisation = groupedSpintossReports[localisation];
                          const locIncome = parseFloat(reportsForLocalisation.reduce((acc, cur) => acc + (cur.TotalAmount || 0), 0).toFixed(3));
                          const locExpenses = parseFloat(reportsForLocalisation.reduce((acc, cur) => acc + (cur.DailyExpenses || 0), 0).toFixed(3));
                          const net = locIncome - locExpenses;
                          return (
                            <tr key={idx}>
                              <td>{localisation}</td>
                              <td>{locIncome.toFixed(3)}</td>
                              <td>{locExpenses.toFixed(3)}</td>
                              <td><span className={net >= 0 ? 'text-success' : 'text-danger'}>{net.toFixed(3)}</span></td>
                            </tr>
                          );
                        })}
                        <tr className="table-total-row">
                          <td>Global</td>
                          <td>{totalIncome.toFixed(3)}</td>
                          <td>{totalDailyExpenses.toFixed(3)}</td>
                          <td><span className={totalIncome - totalDailyExpenses >= 0 ? 'text-success' : 'text-danger'}>{(totalIncome - totalDailyExpenses).toFixed(3)}</span></td>
                        </tr>
                      </tbody>
                    </Table>
                  ) : (
                    <p className="no-data">Aucun rapport disponible pour ce mois.</p>
                  )}
                </div>
              </div>
            </div>

            {/* Détails des demandes */}
            <div className="details-todo-wrapper">
              <div className="table-card details-section">
                <h3>Détails des demandes</h3>
                <Table responsive className="dashboard-table">
                  <thead>
                    <tr>
                      <th>Demandes (Non Confirmées)</th>
                      <th>Envoyées</th>
                      <th>Reçues</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((category) => (
                      <tr key={category}>
                        <td>{category}</td>
                        <td>{countUnconfirmedRequests(myRequests, category)}</td>
                        <td>{countUnconfirmedRequests(myRecivedRequest, category)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
            
          </div>
        </div>
      ) : (
        <Login />
      )}
    </div>
  );
}

export default Home;



// <table>
//         <thead>
//             <tr>
//                 <th>Zone</th>
//                 <th>Pourcentage Conforme</th>
//                 <th>Pourcentage Non Conforme</th>
//             </tr>
//         </thead>
//         <tbody>
//             {Object.keys(zonePercentages).map((zone) => (
//                 <tr key={zone}>
//                     <td>{zone}</td>
//                     <td>{zonePercentages[zone].pourcentageConforme}%</td>
//                     <td>{zonePercentages[zone].pourcentageNonConforme}%</td>
//                 </tr>
//             ))}
//         </tbody>
//     </table> *